module.exports = __webpack_public_path__ + "static/media/logo_arper.0d45048f.svg";